import { ReportSettings, ReportSettingsConfig } from "./report_settings"

const config: ReportSettingsConfig = {
  statusEndpoint: "/organization/weekly-status-report/status",
  requestEndpoint: "/organization/weekly-status-report/request",
  requestButtonText: "Request Weekly Status Reports",
  requestingText: "Sending Request...",
  notReceivingText: "Not Receiving Reports",
  setupRequiredText: "Please configure Gmail or Microsoft integration to receive weekly status reports",
  cooldownDays: 30,
}

export function WeeklyStatusReportSettings() {
  return <ReportSettings config={config} />
}
